module.exports = __webpack_public_path__ + "static/media/prdupldrtemplate.1d5cd400.csv";